import { render } from "./p-date-range.vue?vue&type=template&id=116cfdb6"
import script from "./p-date-range.vue?vue&type=script&lang=js"
export * from "./p-date-range.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__